(function () {
  const STYLE_ID = 'glowe-forms-teaser-style';
  const INITIAL_CHECK_DELAY = 300;
  const RETRY_INTERVAL = 500;

  const observedShadows = new WeakSet();

  function addStyles(shadow) {
    if (shadow.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      button[data-testid="form-teaser"] {
       width: 70px !important;
height: 70px !important;
min-width: 70px !important;
min-height: 70px !important;
        padding: 0 !important;
        margin: 0 !important;
       border-radius: 0 !important;
background: transparent !important;
border: none !important;
box-shadow: none !important;
        position: relative !important;
        display: block !important;
        overflow: visible !important;
        cursor: pointer !important;
      }

      button[data-testid="form-teaser"] h3 {
        display: none !important;
      }

      /* CAJA GLOWE */
      button[data-testid="form-teaser"] .glowe-box-icon {
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
width: 72px !important;
height: 72px !important;
        transform: translate(-50%, -50%) !important;
        object-fit: contain !important;
        display: block !important;
        margin: 0 !important;
        pointer-events: none !important;
      }

      /* BADGE 1 */
      button[data-testid="form-teaser"] .glowe-badge {
        position: absolute !important;
        top: -4px !important;
        right: -4px !important;
        width: 21px !important;
        height: 21px !important;
        padding: 0 !important;
        margin: 0 !important;
        border-radius: 50% !important;
        background: #ef3340 !important;
        color: #fff !important;
        font: 700 12px/21px Arial, sans-serif !important;
        text-align: center !important;
        z-index: 20 !important;
        pointer-events: none !important;
      }

      /* X NATIVA DE SHOPIFY */
button[data-testid="form-teaser"] [aria-label="Close modal"] {
  display: none !important;
}
      button[data-testid="form-teaser"] [aria-label="Close modal"] svg {
        width: 11px !important;
        height: 11px !important;
        stroke: #fff !important;
      }

      button[data-testid="form-teaser"]:hover {
        transform: scale(1.05) !important;
      }

      /* MOBILE */
      @media (max-width: 749px) {
        button[data-testid="form-teaser"] {
          width: 60px !important;
          height: 60px !important;
          min-width: 60px !important;
          min-height: 60px !important;
          transform: translate(8px, -8px) !important;
        }

        button[data-testid="form-teaser"] .glowe-box-icon {
  width: 72px !important;
  height: 72px !important;
        }

        button[data-testid="form-teaser"] .glowe-badge {
          width: 18px !important;
          height: 18px !important;
          font-size: 11px !important;
          line-height: 18px !important;
          top: -3px !important;
          right: -3px !important;
        }

        button[data-testid="form-teaser"] [aria-label="Close modal"] {
          width: 17px !important;
          height: 17px !important;
          min-width: 17px !important;
          min-height: 17px !important;
          left: -2px !important;
          top: -2px !important;
        }

        button[data-testid="form-teaser"] [aria-label="Close modal"] svg {
          width: 10px !important;
          height: 10px !important;
        }
      }
    `;

    shadow.appendChild(style);
  }

  function applyTeaser(shadow) {
    const button = shadow.querySelector(
      'button[data-testid="form-teaser"]'
    );

    if (!button) return;

    /* Caja Glowe */
    let box = button.querySelector('.glowe-box-icon');

    if (!box) {
      const boxUrl = window.GLOWE_TEASER_BOX_URL;

      if (!boxUrl) return;

      box = document.createElement('img');

      box.className = 'glowe-box-icon';
      box.src = boxUrl;
      box.alt = '';
      box.setAttribute('aria-hidden', 'true');

      button.appendChild(box);
    }

    /* Badge */
    let badge = button.querySelector('.glowe-badge');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'glowe-badge';
      badge.textContent = '1';

      button.appendChild(badge);
    }
  }

  function setupShadow(shadow) {
    if (!shadow || observedShadows.has(shadow)) return;

    observedShadows.add(shadow);

    addStyles(shadow);

    const apply = () => {
      applyTeaser(shadow);
    };

    apply();

    const observer = new MutationObserver(() => {
      apply();
    });

    observer.observe(shadow, {
      childList: true,
      subtree: true
    });
  }

  function findFormsShadow() {
    const hosts = document.querySelectorAll('shopify-forms-embed');

    hosts.forEach((host) => {
      if (host.shadowRoot) {
        setupShadow(host.shadowRoot);
      }
    });
  }

  function start() {
    findFormsShadow();

    const documentObserver = new MutationObserver(() => {
      findFormsShadow();
    });

    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(findFormsShadow, INITIAL_CHECK_DELAY);
    setInterval(findFormsShadow, RETRY_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();